import React from 'react'
import SideNav from './SideNav'

const DiningRoomDesigns = () => {
  return (
    <div>
      <>
        <div className="page-header-dining-room-designs parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Dining Room Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">About Us</a>
                    <a href="contact-us" className="btn-default btn-highlighted">Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">

                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="/imgs/dining-room-design.jpg" alt="Dining Room Designs" />
                    </figure>
                  </div>

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      The dining area defines the rhythm of the home — a space for laughter, reflection, and flavor. 
                      <b>MeHome</b> designs dining rooms that merge intimacy with elegance, balancing textures, 
                      lighting, and flow to craft rooms that feel personal yet refined.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Crafted for <span>Gathering & Grace</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      Our approach fuses spatial harmony with understated luxury. From bespoke dining tables to 
                      mood lighting, every element contributes to an inviting environment built for real moments.
                    </p>

                    <ul>
                      <li>Tailored dining layouts designed to suit lifestyle and architecture.</li>
                      <li>Hand-finished furniture created from premium woods and metals.</li>
                      <li>Lighting layers that define atmosphere and depth.</li>
                      <li>Integration with living or kitchen zones for visual continuity.</li>
                      <li>Finishes curated for durability, comfort, and timeless appeal.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Signature <span>Dining Concepts</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🍷</div>
                        <div className="why-choose-item-content">
                          <h3>Modern Minimalism</h3>
                          <p>
                            Crisp lines, neutral palettes, and statement lighting pieces for 
                            a sleek, contemporary look that feels effortless.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">🪑</div>
                        <div className="why-choose-item-content">
                          <h3>Classic Grandeur</h3>
                          <p>
                            Rich wood, soft fabrics, and warm lighting that echo sophistication 
                            and timeless charm in every detail.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">💡</div>
                        <div className="why-choose-item-content">
                          <h3>Lighting Stories</h3>
                          <p>
                            From chandeliers to pendant lamps, we curate lighting that 
                            enhances mood and adds dimension to the dining experience.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1s">
                        <div className="icon-box">🎨</div>
                        <div className="why-choose-item-content">
                          <h3>Artistic Touches</h3>
                          <p>
                            Bespoke wall art, mirrors, and decor installations that 
                            transform your dining room into a visual masterpiece.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.2s">
                        <div className="icon-box">🏡</div>
                        <div className="why-choose-item-content">
                          <h3>Compact Comfort</h3>
                          <p>
                            Ingenious small-space solutions using foldable or modular dining 
                            furniture to make compact homes feel expansive.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                 

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why Homeowners Choose <span>MeHome</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>Design Uniqueness:</b> Every dining project is conceptualized exclusively for you.</li>
                        <li><b>Material Authenticity:</b> We use high-grade finishes built to endure.</li>
                        <li><b>Functional Luxury:</b> Comfort and elegance in perfect balance.</li>
                        <li><b>Seamless Delivery:</b> Transparent timelines and precision execution.</li>
                        <li><b>Comprehensive Care:</b> From consultation to after-installation support.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default DiningRoomDesigns
